<template>
  <div class="camp-signup">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>位置：</el-breadcrumb-item>
      <el-breadcrumb-item>微信管理</el-breadcrumb-item>
      <el-breadcrumb-item>微商城</el-breadcrumb-item>
      <el-breadcrumb-item>营地课程</el-breadcrumb-item>
      <el-breadcrumb-item>营期报名信息</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="conentBox">
      <div class="head-row">
        <div class="title">营期报名信息</div>
        <div class="product-name" v-if="productName">产品：{{ productName }}</div>
        <el-button type="primary" :loading="exporting" @click="exportVisitor">导出学员</el-button>
        <el-button @click="goBack">返回</el-button>
      </div>

      <div class="conentTitle">
        <el-select
          v-model="selectedProductId"
          placeholder="选择产品"
          clearable
          filterable
          @change="onProductChange"
        >
          <el-option
            v-for="item in productList"
            :key="item.id"
            :label="item.product_name"
            :value="String(item.id)"
          ></el-option>
        </el-select>
        <el-select
          v-model="query.product_date_id"
          placeholder="选择营期（导出必选）"
          clearable
          filterable
        >
          <el-option
            v-for="item in dateList"
            :key="item.id"
            :label="dateLabel(item)"
            :value="String(item.id)"
          ></el-option>
        </el-select>
        <el-input placeholder="订单号" v-model="query.order_no" clearable />
        <el-input placeholder="学员姓名" v-model="query.visitor_name" clearable />
        <el-input placeholder="学员手机号" v-model="query.visitor_phone" clearable />
        <el-select v-model="query.order_status" placeholder="订单状态" clearable>
          <el-option label="待支付" value="0"></el-option>
          <el-option label="已支付" value="1"></el-option>
          <el-option label="已取消" value="2"></el-option>
          <el-option label="已退款" value="3"></el-option>
          <el-option label="已使用" value="4"></el-option>
          <el-option label="失效" value="5"></el-option>
        </el-select>
        <el-button type="primary" @click="search">查询</el-button>
      </div>

      <el-table
        :data="tableData"
        v-loading="loading"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
        style="width:100%"
      >
        <el-table-column prop="created_at" label="下单时间" min-width="160"></el-table-column>
        <el-table-column prop="order_no" label="订单号" min-width="180"></el-table-column>
        <el-table-column prop="product_name" label="产品名称" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="spec_name" label="规格" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="name" label="学员姓名" width="100"></el-table-column>
        <el-table-column prop="gender" label="性别" width="70"></el-table-column>
        <el-table-column prop="age" label="年龄" width="70"></el-table-column>
        <el-table-column prop="id_card" label="身份证号" min-width="170" show-overflow-tooltip></el-table-column>
        <el-table-column prop="phone" label="家长联系电话" min-width="130"></el-table-column>
        <el-table-column prop="address" label="家庭住址" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="school" label="就读学校" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="height" label="身高" width="80"></el-table-column>
        <el-table-column prop="weight" label="体重" width="80"></el-table-column>
        <el-table-column prop="shoe_size" label="鞋码" width="80"></el-table-column>
        <el-table-column prop="cert_level" label="已取得的证书板别及级别" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="contact_name" label="联系人" width="100"></el-table-column>
        <el-table-column prop="contact_phone" label="联系电话" width="120"></el-table-column>
        <el-table-column label="订单状态" width="90">
          <template slot-scope="scope">
            {{ statusText(scope.row.order_status) }}
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <span class="demonstration">共{{ total }}条记录，</span>
        <span class="demonstration">当前显示第{{ query.page }}页</span>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="query.page_size"
          :current-page="query.page"
          @current-change="onPageChange"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import {
  campGetOrderList,
  campGetProductList,
  campProductDetail,
  campExportClassVisitor
} from '@/request/scenic.js'

export default {
  name: 'CampSignup',
  data() {
    return {
      loading: false,
      exporting: false,
      tableData: [],
      total: 0,
      productId: '',
      productName: '',
      selectedProductId: '',
      productList: [],
      dateList: [],
      query: {
        product_date_id: '',
        order_no: '',
        visitor_name: '',
        visitor_phone: '',
        order_status: '',
        page: 1,
        page_size: 10
      }
    }
  },
  created() {
    this.productId = this.$route.query.product_id || this.$route.query.id || ''
    this.productName = this.$route.query.product_name || ''
    if (this.productId) {
      this.selectedProductId = String(this.productId)
    }
    this.loadProducts()
    this.getList()
  },
  methods: {
    statusText(v) {
      const map = {
        0: '待支付',
        1: '已支付',
        2: '已取消',
        3: '已退款',
        4: '已使用',
        5: '失效'
      }
      return map[v] != null ? map[v] : map[String(v)] || '-'
    },
    dateLabel(item) {
      const name = item.date_name || '营期'
      if (item.camp_start && item.camp_end) {
        return `${name}（${item.camp_start} ~ ${item.camp_end}）`
      }
      return name
    },
    goBack() {
      this.$router.push({ path: '/wcMall', query: { tab: '4' } })
    },
    search() {
      this.query.page = 1
      this.getList()
    },
    onPageChange(p) {
      this.query.page = p
      this.getList()
    },
    loadProducts() {
      campGetProductList({
        token: window.sessionStorage.getItem('Token'),
        product_type_id: 1,
        page: 1,
        page_size: 200
      }).then(res => {
        if (res.data && (res.data.status === 'ok' || res.data.rcode == 200)) {
          const data = (res.data.result && res.data.result.data) || res.data.result || {}
          this.productList = (data.list || []).map(item => ({
            id: item.id || item.productID || item.product_id,
            product_name: item.product_name || ''
          })).filter(item => item.id)
          if (this.selectedProductId) {
            const hit = this.productList.find(p => String(p.id) === String(this.selectedProductId))
            if (hit) this.productName = hit.product_name
            this.loadDates(this.selectedProductId)
          }
        }
      }).catch(() => {})
    },
    onProductChange(val) {
      this.query.product_date_id = ''
      this.dateList = []
      const hit = this.productList.find(p => String(p.id) === String(val))
      this.productName = hit ? hit.product_name : ''
      this.productId = val || ''
      if (val) {
        this.loadDates(val)
      }
      this.search()
    },
    loadDates(productId) {
      if (!productId) {
        this.dateList = []
        return
      }
      campProductDetail({
        token: window.sessionStorage.getItem('Token'),
        productID: productId,
        product_id: productId,
        id: productId
      }).then(res => {
        if (res.data && (res.data.status === 'ok' || res.data.rcode == 200)) {
          const detail = res.data.result || {}
          const dates = detail.product_date || detail.product_date_arr || []
          this.dateList = (Array.isArray(dates) ? dates : []).map(item => ({
            id: item.id || item.product_date_id,
            date_name: item.date_name || '',
            camp_start: item.camp_start || '',
            camp_end: item.camp_end || ''
          })).filter(item => item.id)
        } else {
          this.dateList = []
        }
      }).catch(() => {
        this.dateList = []
      })
    },
    exportVisitor() {
      if (!this.query.product_date_id) {
        Message.error('请先选择营期后再导出')
        return
      }
      this.exporting = true
      const params = {
        token: window.sessionStorage.getItem('Token'),
        product_date_id: this.query.product_date_id
      }
      if (this.query.visitor_name) {
        params.visitor_name = String(this.query.visitor_name).trim()
      }
      campExportClassVisitor(params).then(res => {
        if (res.data && (res.data.status === 'ok' || res.data.rcode == 200)) {
          const url = res.data.result
          if (typeof url === 'string' && url) {
            window.location.href = url
          } else {
            Message.success((res.data && res.data.msg) || '导出成功')
          }
        } else {
          Message.error((res.data && res.data.msg) || '导出失败')
        }
      }).catch(() => {
        Message.error('导出失败')
      }).finally(() => {
        this.exporting = false
      })
    },
    getList() {
      this.loading = true
      const params = {
        token: window.sessionStorage.getItem('Token'),
        page: this.query.page,
        page_size: this.query.page_size
      }
      if (this.productName) params.product_name = this.productName
      if (this.query.order_no) params.order_no = this.query.order_no
      if (this.query.order_status !== '' && this.query.order_status != null) {
        params.order_status = this.query.order_status
      }
      if (this.query.product_date_id) {
        params.product_date_id = this.query.product_date_id
      }
      campGetOrderList(params).then(res => {
        if (res.data && (res.data.status === 'ok' || res.data.rcode == 200)) {
          const result = res.data.result || {}
          const list = result.list || []
          let rows = []
          list.forEach(order => {
            const visitors = Array.isArray(order.visitor_list) ? order.visitor_list : []
            if (!visitors.length) {
              rows.push(this.mapRow(order, {}))
              return
            }
            visitors.forEach(v => {
              rows.push(this.mapRow(order, v || {}))
            })
          })
          if (this.query.visitor_name) {
            const kw = String(this.query.visitor_name).trim()
            rows = rows.filter(r => String(r.name || '').indexOf(kw) > -1)
          }
          if (this.query.visitor_phone) {
            const kw = String(this.query.visitor_phone).trim()
            rows = rows.filter(r => String(r.phone || '').indexOf(kw) > -1)
          }
          this.tableData = rows
          this.total = result.total || rows.length
        } else {
          this.tableData = []
          this.total = 0
          if (res.data && res.data.msg) Message.error(res.data.msg)
        }
      }).catch(() => {
        this.tableData = []
        this.total = 0
        Message.error('获取报名信息失败')
      }).finally(() => {
        this.loading = false
      })
    },
    mapRow(order, visitor) {
      return {
        created_at: order.created_at || '',
        order_no: order.order_no || '',
        product_name: order.product_name || this.productName || '',
        spec_name: order.spec_name || '',
        contact_name: order.contact_name || '',
        contact_phone: order.contact_phone || '',
        order_status: order.order_status,
        name: visitor.name || '',
        gender: visitor.gender || '',
        age: visitor.age !== undefined && visitor.age !== null ? visitor.age : '',
        id_card: visitor.id_card || visitor.certificate || '',
        phone: visitor.phone || '',
        address: visitor.address || '',
        school: visitor.school || '',
        height: visitor.height || '',
        weight: visitor.weight || '',
        shoe_size: visitor.shoe_size || '',
        cert_level: visitor.cert_level || '',
        remark: visitor.remark || ''
      }
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({ row, column, rowIndex, columnIndex })
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({ row, rowIndex })
    }
  }
}
</script>

<style lang="less" scoped>
.conentBox {
  margin-top: 17px;
}
.head-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }
  .product-name {
    flex: 1;
    color: #666;
    font-size: 14px;
  }
  .el-button--primary {
    background: #246DEB;
    border-color: #246DEB;
  }
}
.conentTitle {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  .el-input, .el-select {
    width: 180px;
  }
  .el-button--primary {
    background: #246DEB;
    border-color: #246DEB;
  }
}
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 42px auto;
  span {
    font-size: 14px;
    color: #000;
  }
}
</style>
